module.exports = __webpack_public_path__ + "static/computing2020-f131294ff0d454c4b10094a8e9f292bf.svg";